/**
 * Map of nav routes to their lazy chunk loaders.
 * Triggering on `mouseenter` warms the chunk so the click navigation feels instant.
 * Vite dedupes concurrent imports so calling these repeatedly is safe.
 */
const PREFETCHERS: Record<string, () => Promise<unknown>> = {
  "/vet-directory": () => import("@/pages/VetDirectory.tsx"),
  "/how-it-works": () => import("@/pages/HowItWorks.tsx"),
  "/symptom-sniffer": () => import("@/pages/SymptomSniffer.tsx"),
  "/getvideovet": () => import("@/pages/GetVideoVet.tsx"),
  "/getpetpassport": () => import("@/pages/GetPetPassport.tsx"),
};

const prefetched = new Set<string>();

export function prefetchRoute(path: string) {
  if (prefetched.has(path)) return;
  const loader = PREFETCHERS[path];
  if (!loader) return;
  prefetched.add(path);
  loader().catch(() => {
    // Prefetch failures are non-fatal; the real navigation will retry.
    prefetched.delete(path);
  });
}
